export class ServiceMenuFormModel {
  constructor(serviceMenu = {}) {
    this.title = serviceMenu?.title || "";
    this.price = serviceMenu?.price || "";
    this.available = serviceMenu?.available || false;
    this.description = serviceMenu?.description || "";
    this.serviceTypeKey = serviceMenu?.serviceTypeKey || "";
  }
}
